// Non-authoritative, per-tab navigation context. Never used for API calls.
const ACCOUNT_KEY = 'handoff.account';
export const accountId = (raw: unknown): string | null =>
  typeof raw === 'string' && raw.trim() === raw && /^[0-9]+$/.test(raw)
    ? raw
    : null;

export const handoffAccount = (
  search: string,
  state?: unknown
): string | null => {
  const fallback = accountId(
    typeof state === 'object' && state !== null
      ? (state as Record<string, unknown>).handoff_account
      : null
  );
  const incoming = accountId(new URLSearchParams(search).get('a'));
  try {
    if (incoming !== null) sessionStorage.setItem(ACCOUNT_KEY, incoming);
    return (
      incoming ?? accountId(sessionStorage.getItem(ACCOUNT_KEY)) ?? fallback
    );
  } catch {
    return incoming ?? fallback;
  }
};
